{
  "APP_NAME": "verein.cloud®",
  "Verein": "Verein",
  "Vereins": "Vereins",
  "ABOUT_VEREIN": "verein.cloud® ile prim gelirlerinin ötesinde ek değerler ve gelir kaynakları sunuyoruz. Bir bağış platformu, planların ve projelerin finansmanına otomatik erişim sağlar. Kulüp üyelerine yönelik profilli erişim sayesinde kulüpler, sponsorlarını daha sürdürülebilir şekilde entegre edebilir. Üyeler ve dernekler, sadakat, kupon veya nakit geri ödeme işlevleri ve diğer ek avantajlar ve hizmetlerden yararlanır.",
  "PASSWORD_RESET_SUCCESS_MESSAGE": "Bir şifre sıfırlama bağlantısı gönderildi. Lütfen gelen kutunuzu kontrol edin ve support@verein.cloud adresinden gelen e-postayı arayın.",
  "New Version is Available.": "Yeni Sürüm Mevcut.",
  "Please Click to Update": "Lütfen Güncellemek İçin Tıklayın",
  "Forgot Password": "Şifremi Unuttum",
  "Back to login": "Girişe Geri Dön",
  "Submit": "Gönder",
  "Welcome": "Hoş geldiniz",
  "Login Successful": "Giriş Başarılı",
  "Admin": "Yönetici",
  "Member": "Üye",
  "Guest": "Misafir",
  "Secretary": "Sekreter",
  "Functionary": "Görevli",
  "Editor": "Editör",
  "User": "Kullanıcı",
  "Member Light": "Üye Light",
  "Member Light Admin": "Üye Light Admin",
  "About": "Hakkında",
  "Chairman": "Başkan",
  "Hello world !": "Merhaba dünya!",
  "Not Found": "Bulunamadı",
  "Unauthorized Access": "Yetkisiz Erişim",
  "Home": "Anasayfa",
  "Logged in as": "Olarak giriş yapıldı",
  "Login": "Giriş Yap",
  "Logout": "Çıkış Yap",
  "Confirm Password": "Şifreyi Onayla",
  "Password": "Şifre",
  "Password is required": "Şifre gerekli",
  "Username": "Kullanıcı Adı",
  "Username is required": "Kullanıcı adı gerekli",
  "Username or password incorrect.": "Kullanıcı adı veya şifre hatalı.",
  "Remember me": "Beni hatırla",
  "Version": "Sürüm",
  "Details": "Detaylar",
  "Yes": "Evet",
  "No": "Hayır",
  "Old Password": "Eski Şifre",
  "New Password": "Yeni Şifre",
  "Confirmation": "Onay",
  "Delete Confirmation": "Silme Onayı",
  "Move to Trash Confirmation": "Çöp Kutusuna Taşıma Onayı",
  "Leave Confirmation": "Ayrılma Onayı",
  "Join Confirmation": "Katılma Onayı",
  "Approve Join Confirmation": "Katılma Onayı",
  "Accept Confirmation": "Kabul Onayı",
  "Deny Confirmation": "Reddetme Onayı",
  "Approve Confirmation": "Onaylama Onayı",
  "Reject Confirmation": "Reddetme Onayı",
  "Shifts Delete Confirmation": "Vardiyaları Silme Onayı",
  "Accept Successful": "Kabul Başarılı",
  "Deny Successful": "Reddetme Başarılı",
  "Unapprove Successful": "Onay Kaldırma Başarılı",
  "Approve Successful": "Onay Başarılı",
  "Created Successfully": "Başarıyla Oluşturuldu",
  "Update Successful": "Güncelleme Başarılı",
  "Delete Successful": "Silme Başarılı",
  "Leave Successful": "Ayrılma Başarılı",
  "Join Successful": "Katılma Başarılı",
  "Approved Successfully": "Başarıyla Onaylandı",
  "Rejected Successfully": "Başarıyla Reddedildi",
  "Message moved to inbox successfully": "Mesaj başarıyla gelen kutusuna taşındı",
  "Message saved as draft successfully": "Mesaj taslak olarak başarıyla kaydedildi",
  "Message moved to trash successfully": "Mesaj başarıyla çöp kutusuna taşındı",
  "Message starred successfully": "Mesaj başarıyla işaretlendi",
  "Error": "Hata",
  "Something went wrong": "Bir şeyler ters gitti!",
  "Are you sure you want to continue": "Devam etmek istediğinize emin misiniz",
  "Are you sure you want to delete": "Silmek istediğinize emin misiniz",
  "Are you sure you want to leave": "Ayrılmak istediğinize emin misiniz",
  "Are you sure you want to join": "Katılmak istediğinize emin misiniz",
  "Are you sure you want to join {eventName} event on {eventDate}?": "Are you sure you want to join <b>'{{eventName}}'</b> etkinliğine <b>{{eventDate}}</b> tarihinde katılmak istediğinize emin misiniz?",
  "Are you sure you want to join {eventName} for all upcoming events?": "Are you sure you want to joint <b>'{{eventName}}'</b> for all upcoming events?",
  "Are you sure you want to join {eventName} event on selected dates?": "Are you sure you want to join <b>'{{eventName}}'</b> etkinliğine seçilen tarihlerde katılmak istediğinize emin misiniz?",
  "Your current Request is waiting for the Approval": "Mevcut isteğiniz onay bekliyor.",
  "Current Request is waiting for the Approval by Admin": "Mevcut istek, Yönetici onayını bekliyor.",
  "Current request has been denied": "Mevcut talep reddedildi",
  "Your current request is Rejected": "Mevcut talebiniz reddedildi.",
  "Your current request is Approved": "Mevcut talebiniz onaylandı.",
  "Deny Reason": "Reddetme Nedeni",
  "Your current Request is waiting for the Approval by Admin": "Mevcut talebiniz Yönetici onayını bekliyor.",
  "Your current request is Denied by Admin": "Mevcut talebiniz Yönetici tarafından reddedildi.",
  "Your update request is waiting for the approval by Admin": "Güncelleme talebiniz Yönetici onayını bekliyor.",
  "Update request is waiting for the approval": "Güncelleme talebi onay bekliyor",
  "You have unsaved changes. Are you sure you want to leave": "Kaydedilmemiş değişiklikleriniz var. Ayrılmak istediğinize emin misiniz",
  "confirmationDivider": "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------",
  "Are you sure you want to accept this": "Bunu kabul etmek istediğinize emin misiniz",
  "Are you sure you want to deny this": "Bunu reddetmek istediğinize emin misiniz",
  "Are you sure you want to approve this": "Bunu onaylamak istediğinize emin misiniz",
  "Are you sure you want to reject this": "Bunu reddetmek istediğinize emin misiniz",
  "Are you sure you want to unapprove this": "Bunun onayını kaldırmak istediğinize emin misiniz",
  "Are you sure you want to accept this Course": "Bu Kursu kabul etmek istediğinize emin misiniz",
  "Are you sure you want to deny this Course": "Bu Kursu reddetmek istediğinize emin misiniz",
  "Are you sure you want to approve this Course": "Bu Kursu onaylamak istediğinize emin misiniz",
  "Are you sure you want to reject this Course": "Bu Kursu reddetmek istediğinize emin misiniz",
  "Are you sure you want to unapprove this Course": "Bu Kursu onaylamamak istediğinize emin misiniz",
  "Are you sure you want to accept this Event": "Bu Etkinliği kabul etmek istediğinize emin misiniz",
  "Are you sure you want to deny this Event": "Bu Etkinliği reddetmek istediğinize emin misiniz",
  "Are you sure you want to approve this Event": "Bu Etkinliği onaylamak istediğinize emin misiniz",
  "Are you sure you want to reject this Event": "Bu Etkinliği reddetmek istediğinize emin misiniz",
  "Are you sure you want to unapprove this Event": "Bu Etkinliği onaylamamak istediğinize emin misiniz",
  "Are you sure you want to accept this News": "Bu Haberi kabul etmek istediğinize emin misiniz",
  "Are you sure you want to deny this News": "Bu Haberi reddetmek istediğinize emin misiniz",
  "Are you sure you want to approve this News": "Bu Haberi onaylamak istediğinize emin misiniz",
  "Are you sure you want to reject this News": "Bu Haberi reddetmek istediğinize emin misiniz",
  "Are you sure you want to unapprove this News": "Bu Haberi onaylamamak istediğinize emin misiniz",
  "Are you sure you want to accept this Task": "Bu Görevi kabul etmek istediğinize emin misiniz",
  "Are you sure you want to deny this Task": "Bu Görevi reddetmek istediğinize emin misiniz",
  "Are you sure you want to approve this Task": "Bu Görevi onaylamak istediğinize emin misiniz",
  "Are you sure you want to reject this Task": "Bu Görevi reddetmek istediğinize emin misiniz",
  "Are you sure you want to unapprove this Task": "Bu Görevi onaylamamak istediğinize emin misiniz",
  "Are you sure you want to accept this Group": "Bu Grubu kabul etmek istediğinize emin misiniz",
  "Are you sure you want to deny this Group": "Bu Grubu reddetmek istediğinize emin misiniz",
  "Are you sure you want to approve this Group": "Bu Grubu onaylamak istediğinize emin misiniz",
  "Are you sure you want to reject this Group": "Bu Grubu reddetmek istediğinize emin misiniz",
  "Are you sure you want to unapprove this Group": "Bu Grubu onaylamamak istediğinize emin misiniz",
  "Are you sure you want to accept this FAQ": "Bu SSS'yi kabul etmek istediğinize emin misiniz",
  "Are you sure you want to deny this FAQ": "Bu SSS'yi reddetmek istediğinize emin misiniz",
  "Are you sure you want to approve this FAQ": "Bu SSS'yi onaylamak istediğinize emin misiniz",
  "Are you sure you want to reject this FAQ": "Bu SSS'yi reddetmek istediğinize emin misiniz",
  "Are you sure you want to unapprove this FAQ": "Bu SSS'yi onaylamamak istediğinize emin misiniz",
  "Are you sure you want to accept this Instructor": "Bu Eğitmeni kabul etmek istediğinize emin misiniz",
  "Are you sure you want to deny this Instructor": "Bu Eğitmeni reddetmek istediğinize emin misiniz",
  "Are you sure you want to approve this Instructor": "Bu Eğitmeni onaylamak istediğinize emin misiniz",
  "Are you sure you want to reject this Instructor": "Bu Eğitmeni reddetmek istediğinize emin misiniz",
  "Are you sure you want to unapprove this Instructor": "Bu Eğitmeni onaylamamak istediğinize emin misiniz",
  "Are you sure you want to accept this Room": "Bu Odayı kabul etmek istediğinize emin misiniz",
  "Are you sure you want to deny this Room": "Bu Odayı reddetmek istediğinize emin misiniz",
  "Are you sure you want to approve this Room": "Bu Odayı onaylamak istediğinize emin misiniz",
  "Are you sure you want to reject this Room": "Bu Odayı reddetmek istediğinize emin misiniz",
  "Are you sure you want to unapprove this Room": "Bu Odayı onaylamamak istediğinize emin misiniz",
  "Are you sure you want to accept this Survey": "Bu Anketi kabul etmek istediğinize emin misiniz",
  "Are you sure you want to deny this Survey": "Bu Anketi reddetmek istediğinize emin misiniz",
  "Are you sure you want to approve this Survey": "Bu Anketi onaylamak istediğinize emin misiniz",
  "Are you sure you want to reject this Survey": "Bu Anketi reddetmek istediğinize emin misiniz",
  "Are you sure you want to unapprove this Survey": "Bu Anketi onaylamamak istediğinize emin misiniz",
  "Are you sure you want to delete all shifts for": "Bu kullanıcıya ait tüm vardiyaları silmek istediğinize emin misiniz",
  "Are you sure you want to move this to trash": "Bunu çöp kutusuna taşımak istediğinize emin misiniz",
  "Are you sure you want to permanently delete this": "Bunu kalıcı olarak silmek istediğinize emin misiniz",
  "Are you sure you want to approve this join request": "Bu katılma isteğini onaylamak istediğinize emin misiniz",
  "Are you sure you want to delete this image": "Bu resmi silmek istediğinize emin misiniz",
  "Are you sure you want to delete this document": "Bu belgeyi silmek istediğinize emin misiniz",
  "Are you sure you want to complete this task": "Bu görevi tamamlamak istediğinize emin misiniz",
  "payment information": "ödeme bilgileri",
  "Android App": "Android Uygulaması",
  "iOS App": "iOS Uygulaması",
  "Club Surveys": "Kulüp Anketleri",
  "Active Polls": "Aktif Anketler",
  "My Polls": "Anketlerim",
  "Completed Polls": "Tamamlanan Anketler",
  "Completed Surveys": "Tamamlanan Anketler",
  "Opinion Poll": "Görüş Anketi",
  "owner": "Sahip",
  "Active on": "Aktif olduğu tarih",
  "Active from": "Aktif başlangıç tarihi",
  "Expired on": "Süresi doldu",
  "remaining time": "kalan süre",
  "status": "Durum",
  "Change Password": "Şifre Değiştir",
  "Add Survey": "Anket Ekle",
  "View Survey": "Anketi Görüntüle",
  "Delete Survey": "Anketi Sil",
  "Active Survey": "Aktif Anket",
  "Close Survey": "Anketi Kapat",
  "Survey Activated Successfully": "Anket başarıyla etkinleştirildi",
  "Survey Closed Successfully": "Anket başarıyla kapatıldı",
  "Survey Close Confirmation": "Anket Kapatma Onayı",
  "Survey Active Confirmation": "Anketi Etkinleştirme Onayı",
  "Are you sure you want to active": "Etkinleştirmek istediğinize emin misiniz",
  "Are you sure you want to close": "Kapatmak istediğinize emin misiniz",
  "Leave": "Ayrıl",
  "Edit": "Düzenle",
  "Delete": "Sil",
  "Remove": "Kaldır",
  "Add": "Ekle",
  "Create": "Oluştur",
  "Save": "Kaydet",
  "Update": "Güncelle",
  "update": "Güncelle",
  "Cancel": "İptal",
  "Back": "Geri",
  "accept": "Kabul et",
  "Accept": "Kabul Et",
  "Decline": "Reddet",
  "deny": "Reddet",
  "Deny": "Reddet",
  "view": "Görüntüle",
  "View": "Görüntüle",
  "view survey": "Anketi görüntüle",
  "view task": "Görevi görüntüle",
  "View Task": "Görevi Görüntüle",
  "Drag and drop image here, or click to add image": "Görüntüyü buraya sürükleyin veya eklemek için tıklayın",
  "Drag and drop image here, or click to change image": "Görüntüyü buraya sürükleyin veya değiştirmek için tıklayın",
  "Drag and drop file here, or click to add file": "Dosyayı buraya sürükleyin veya eklemek için tıklayın",
  "Drag and drop file here, or click to change file": "Dosyayı buraya sürükleyin veya değiştirmek için tıklayın",
  "Add Image": "Görüntü Ekle",
  "Add File": "Dosya Ekle",
  "Change Image": "Görüntüyü Değiştir",
  "View more": "Daha fazla görüntüle",
  "Notifications": "Bildirimler",
  "See more Notifications": "Daha fazla bildirim görüntüle",
  "Title": "Başlık",
  "Start Date": "Başlangıç Tarihi",
  "End Date": "Bitiş Tarihi",
  "New Survey": "Yeni Anket",
  "Survey Edit": "Anket Düzenle",
  "Survey Details": "Anket Detayları",
  "Survey": "Anket",
  "Question": "Soru",
  "Single selection": "Tekli seçim",
  "Multiple selection": "Çoklu seçim",
  "Add Choice": "Seçenek Ekle",
  "Enter your question": "Sorunuzu girin",
  "Publish": "Yayınla",
  "Add Question": "Soru Ekle",
  "Enter your survey name": "Anket adını girin",
  "Assigned tasks": "Atanan görevler",
  "About event": "Etkinlik hakkında",
  "Event details": "Etkinlik Detayları",
  "Clear All": "Hepsini Temizle",
  "Select Date": "Tarih Seç",
  "Delete Banner": "Afişi Sil",
  "Banner": "Afiş",
  "Banners": "Afişler",
  "Logo": "Logo",
  "Footer": "Altbilgi",
  "Email Type": "E-posta Türü",
  "Subject": "Konu",
  "To": "Kime",
  "Cc": "Cc",
  "Recipients": "Alıcılar",
  "Edit Draft Message": "Taslak Mesajı Düzenle",
  "Header Content": "Üstbilgi İçeriği",
  "Template Body": "Şablon Gövdesi",
  "Footer Content": "Altbilgi İçeriği",
  "Url": "URL",
  "Action": "Eylem",
  "Thumbnail": "Küçük Resim",
  "From": "Kimden",
  "Template Type": "Şablon Türü",
  "Header Subject": "Üstbilgi Konusu",
  "Email Template": "E-posta Şablonu",
  "Create Email Template": "E-posta Şablonu Oluştur",
  "Content": "İçerik",
  "instructor": "Eğitmen",
  "survey": "Anket",
  "course": "Kurs",
  "updatedcourse": "Güncellenmiş Kurs",
  "Select Option": "Seçenek Seç",
  "Select Options": "Seçenekleri Seç",
  "Tag": "Etiket",
  "Tags": "Etiketler",
  "Tag Name": "Etiket Adı",
  "Create Tag": "Etiket Oluştur",
  "Instructor Tag Name": "Eğitmen Etiket Adı",
  "Room Tag Name": "Oda Etiket Adı",
  "Courses": "Kurslar",
  "Instructor": "Eğitmen",
  "Room": "Oda",
  "Rooms": "Odalar",
  "New Tag": "Yeni Etiket",
  "Task": "Görev",
  "task": "görev",
  "Event": "Etkinlik",
  "Events": "Etkinlikler",
  "Event Name": "Etkinlik Adı",
  "Event Type": "Etkinlik Türü",
  "FAQs": "SSS",
  "Surveys": "Anketler",
  "News": "Haberler",
  "news": "haberler",
  "news posts": "Haber Gönderileri",
  "news post": "Haber Gönderisi",
  "create news post": "Haber Gönderisi Oluştur",
  "edit news post": "Haber Gönderisini Düzenle",
  "news post details": "Haber Gönderisi Detayları",
  "discover": "Keşfet",
  "create news": "Haber Oluştur",
  "news from the groups": "Gruplardan haberler",
  "No Available Content": "Mevcut İçerik Yok",
  "re you sure you want to delete this Tag?": "Bu etiketi silmek istediğinizden emin misiniz?",
  "Update Tag": "Etiketi Güncelle",
  "Add task": "Görev Ekle",
  "Tasks": "Görevler",
  "Task details": "Görev Detayları",
  "Create task": "Görev Oluştur",
  "Edit task": "Görevi Düzenle",
  "All tasks": "Tüm Görevler",
  "My tasks": "Görevlerim",
  "Completed tasks": "Tamamlanan Görevler",
  "Open tasks": "Açık Görevler",
  "Group tasks": "Grup Görevleri",
  "New task": "Yeni Görev",
  "Subtasks": "Alt Görevler",
  "Add Sub-task": "Alt Görev Ekle",
  "Select date": "Tarih Seç",
  "Select Time": "Zaman Seç",
  "ToDo": "Yapılacak",
  "In-Progress": "Devam Ediyor",
  "InProgress": "Devam Ediyor",
  "Completed": "Tamamlandı",
  "Comments": "Yorumlar",
  "Assigned": "Atandı",
  "Assign to": "Atanacak kişi",
  "Add a Card": "Kart Ekle",
  "Add Card": "Kart Ekle",
  "Add element": "Öğe Ekle",
  "Enter a title for this card": "Bu kart için bir başlık girin",
  "Tasks to be completed": "Tamamlanacak görevler",
  "Group": "Grup",
  "Individual": "Bireysel",
  "Task type": "Görev Türü",
  "Add Tag": "Etiket Ekle",
  "Enter Title": "Başlık Girin",
  "Enter Description": "Açıklama Girin",
  "Select": "Seç",
  "News Posts": "Haber Gönderileri",
  "Posts": "Gönderiler",
  "Message Chats": "Mesaj Sohbetleri",
  "Message": "Mesaj",
  "Chats": "Sohbetler",
  "Tasks Events": "Görev Etkinlikleri",
  "news from the club": "Kulüpten haberler",
  "News from the group": "Gruptan haberler",
  "News from the Company": "Şirketten Haberler",
  "Current club dates": "Güncel kulüp tarihleri",
  "Current company dates": "Güncel şirket tarihleri",
  "Participant": "Katılımcı",
  "Read more": "Daha Fazla Oku",
  "Clock": "Saat",
  "Popular": "Popüler",
  "Latest": "En Son",
  "Available Tasks": "Mevcut Görevler",
  "Available": "Mevcut",
  "New": "Yeni",
  "No News": "Haber Yok",
  "Menu": "Menü",
  "Answer Options": "Cevap Seçenekleri",
  "Enter answer choice": "Cevap seçeneğini girin",
  "Answer": "Cevap",
  "Survey Type": "Anket Türü",
  "Type": "Tür",
  "View Options": "Seçenekleri Görüntüle",
  "Notification": "Bildirim",
  "Anonymous Voting": "Anonim Oy",
  "Allow Correcting the Cast Vote": "Verilen Oyu Düzeltmeye İzin Ver",
  "Multiple Choice": "Çoktan Seçmeli",
  "Single Choice": "Tek Seçimli",
  "Web Notification": "Web Bildirimi",
  "Email Notification": "E-posta Bildirimi",
  "Always": "Her Zaman",
  "After Voting": "Oy Kullandıktan Sonra",
  "Never": "Asla",
  "All Club": "Tüm Kulüp",
  "All Important Dates": "Tüm Önemli Tarihler",
  "Jubilees": "Yıldönümleri",
  "Birthdays": "Doğum Günleri",
  "Anniversary": "Yıldönümü",
  "Birthday": "Doğum Günü",
  "days ago": "gün önce",
  "days left": "gün kaldı",
  "years": "yıl",
  "years in club": "kulüpteki yıl",
  "Today": "Bugün",
  "Today is": "Bugün",
  "No upcoming birthdays or anniversaries": "Yaklaşan doğum günü veya yıldönümü yok",
  "Say Congrats": "Tebrik et",
  "Reply": "Yanıtla",
  "Reply All": "Tümünü Yanıtla",
  "Forward": "Yönlendir",
  "No Messages": "Mesaj Yok",
  "All Events": "Tüm Etkinlikler",
  "Club Event": "Kulüp Etkinlikleri",
  "Group Event": "Grup Etkinlikleri",
  "Functionaries Event": "Görevliler Etkinlikleri",
  "Course": "Kurs",
  "Seminar": "Seminer",
  "Items Per Page": "Sayfa Başına Öğeler",
  "Description": "Açıklama",
  "Enter to search": "Aramak için Enter'a basın",
  "New Chat": "Yeni Sohbet",
  "New Email": "Yeni E-posta",
  "Email": "E-posta",
  "E-Mail": "E-Posta",
  "Select an email to start communication": "İletişime başlamak için bir e-posta seçin",
  "Select a chat to start messaging": "Mesajlaşmaya başlamak için bir sohbet seçin",
  "Looks like you haven’t initiated a conversation with any of your team members": "Ekibinizden kimseyle bir konuşma başlatmamış görünüyorsunuz",
  "Enter your survey description": "Anket açıklamanızı girin",
  "Manage members and set their access level in your workspace": "Üyeleri yönetin ve çalışma alanınızda erişim seviyelerini belirleyin",
  "New Message": "Yeni Mesaj",
  "Message Type": "Mesaj Türü",
  "Add a subject...": "Bir konu ekleyin...",
  "Select A Message": "Bir Mesaj Seçin",
  "Choose File": "Dosya Seç",
  "Change File": "Dosyayı Değiştir",
  "Type a message...": "Bir mesaj yaz...",
  "Draft": "Taslak",
  "Drafts": "Taslaklar",
  "Send": "Gönder",
  "Bin": "Çöp Kutusu",
  "All Messages": "Tüm Mesajlar",
  "Posted": "Gönderildi",
  "Marked": "İşaretlendi",
  "Inbox": "Gelen Kutusu",
  "Trash": "Çöp Kutusu",
  "Starred": "Yıldızlı",
  "Sent": "Gönderilenler",
  "All Mails": "Tüm Postalar",
  "Personal": "Kişisel",
  "Sorting": "Sıralama",
  "Active Member": "Aktif Üye",
  "Membership number": "Üyelik numarası",
  "In the team since": "Takımda olduğu tarih",
  "In the club since": "Kulüpte olduğu tarih",
  "Category": "Kategori",
  "Position": "Pozisyon",
  "Category Name": "Kategori Adı",
  "Select Language": "Dil Seç",
  "Select Theme": "Tema Seç",
  "No record found": "Kayıt bulunamadı",
  "No items available": "Kullanılabilir öğe yok",
  "No tags available": "Kullanılabilir etiket yok",
  "Internal": "Dahili",
  "External": "Harici",
  "Booked Out": "Rezerve Edildi",
  "Internal Instructor": "Dahili Eğitmen",
  "External Instructor": "Harici Eğitmen",
  "Instructor Type": "Eğitmen Türü",
  "Faq Category": "SSS Kategorisi",
  "Faq Category Name": "SSS Kategori Adı",
  "Sort and Filter": "Sırala ve Filtrele",
  "Clear": "Temizle",
  "Select Tags": "Etiketleri Seç",
  "Name of the Event": "Etkinliğin Adı",
  "Venue": "Mekan",
  "Add Venue": "Mekan Ekle",
  "No venue available": "Kullanılabilir mekan yok",
  "Event Venues": "Etkinlik Mekanları",
  "Create Event Venue": "Etkinlik Mekanı Oluştur",
  "Event Venue Name": "Etkinlik Mekanı Adı",
  "Event Types": "Etkinlik Türleri",
  "Visibility of Event": "Etkinliğin Görünürlüğü",
  "Show Guests": "Misafirleri Göster",
  "Chargeable": "Ücretli",
  "Additional Features": "Ek Özellikler",
  "Event Price": "Etkinlik Ücreti",
  "Assign a task to an event": "Bir etkinliğe görev ata",
  "Task Description": "Görev Açıklaması",
  "Task Types": "Görev Türleri",
  "Week Days": "Hafta Günleri",
  "Recurrence": "Tekrarlama",
  "Start Time": "Başlangıç Saati",
  "End Time": "Bitiş Saati",
  "Event Date": "Etkinlik Tarihi",
  "Event Time": "Etkinlik Saati",
  "Room No (optional)": "Oda No (isteğe bağlı)",
  "Repeat Event": "Etkinliği Tekrarla",
  "Image": "Görüntü",
  "Enter Price": "Fiyat Girin",
  "Time From": "Başlangıç Zamanı",
  "Time To": "Bitiş Zamanı",
  "Every": "Her",
  "Days": "Gün",
  "Weeks": "Hafta",
  "Months": "Ay",
  "Years": "Yıl",
  "Day": "Gün",
  "Repeat Daily": "Günlük Tekrarla",
  "Repeat Weekly": "Haftalık Tekrarla",
  "Repeat Monthly": "Aylık Tekrarla",
  "Repeat Yearly": "Yıllık Tekrarla",
  "Public": "Herkese Açık",
  "Private": "Özel",
  "Club": "Kulüp",
  "Clubs": "Kulüpler",
  "Company": "Şirket",
  "Does Not Repeat": "Tekrarlama",
  "Every Day": "Her Gün",
  "Every Week": "Her Hafta",
  "Every Month": "Her Ay",
  "Every Year": "Her Yıl",
  "Custom": "Özel",
  "Club  Event": "Kulüp Etkinliği",
  "Select Participants": "Katılımcıları Seç",
  "Participants": "Katılımcılar",
  "Private Group": "Özel Grup",
  "Course Information": "Kurs Bilgisi",
  "Place": "Yer",
  "Date": "Tarih",
  "Time": "Saat",
  "Instructor Name": "Eğitmen Adı",
  "Available Times": "Uygun Zamanlar",
  "Qualification": "Yeterlilik",
  "More Courses": "Daha Fazla Kurs",
  "Theme": "Tema",
  "Room Information": "Oda Bilgisi",
  "Task Details": "Görev Detayları",
  "Assignment": "Atama",
  "Due Date": "Son Tarih",
  "Room Details": "Oda Detayları",
  "Address": "Adres",
  "People": "Kişiler",
  "Pending": "Bekliyor",
  "Approved": "Onaylandı",
  "Room Info": "Oda Bilgisi",
  "To be submitted at the of course": "Kurs sonunda teslim edilecektir",
  "Add Course": "Kurs Ekle",
  "Add Location": "Konum Ekle",
  "Add Tags": "Etiket Ekle",
  "Course Date": "Kurs Tarihi",
  "Allowed Persons": "İzin Verilen Kişi Sayısı",
  "Add a Title": "Bir Başlık Ekle",
  "Headline": "Manşet",
  "Types": "Türler",
  "Enter headline": "Manşet girin",
  "Enter content": "İçerik girin",
  "News Highlight": "Haber Vurgusu",
  "Club News": "Kulüp Haberleri",
  "Company News": "Şirket Haberleri",
  "New from the club": "Kulüpten yeni haberler",
  "New Posts": "Yeni Gönderiler",
  "Task Events": "Görev Etkinlikleri",
  "Delete Group": "Grubu Sil",
  "Groups": "Gruplar",
  "Group Details": "Grup Detayları",
  "Leave Group": "Gruptan Ayrıl",
  "Join Group": "Gruba Katıl",
  "Group Name": "Grup Adı",
  "Course Name": "Kurs Adı",
  "Visibility": "Görünürlük",
  "No file chosen": "Dosya seçilmedi",
  "Assign a task to course": "Kursa görev ata",
  "Please fill all required fields": "Lütfen tüm gerekli alanları doldurun",
  "Room Availability": "Oda Müsaitliği",
  "Room Capacity": "Oda Kapasitesi",
  "Room Charges": "Oda Ücretleri",
  "Room Current Bookings": "Odada Mevcut Rezervasyonlar",
  "Instructor Availability": "Eğitmen Müsaitliği",
  "Instructor Current Bookings": "Eğitmende Mevcut Rezervasyonlar",
  "Instructor not available for the following dates and times": "Eğitmen şu tarih ve saatlerde müsait değil",
  "Room not available for the following dates and times": "Oda şu tarih ve saatlerde müsait değil",
  "Not within availability": "Müsaitlik içinde değil",
  "Add News": "Haber Ekle",
  "Waiting for Approval": "Onay Bekliyor",
  "Survey Results": "Anket Sonuçları",
  "Survey Results Details": "Anket Sonuç Detayları",
  "Survey Created By": "Anket Oluşturan",
  "Survey Has been Closed": "Anket Kapatıldı",
  "You've not voted": "Oy kullanmadınız",
  "My Vote": "Oyum",
  "To Vote": "Oy Kullan",
  "My Vote: You can select Multiple Options": "Oyum: Birden Fazla Seçenek Seçebilirsiniz",
  "My Vote: You can select only one option": "Oyum: Yalnızca bir seçenek seçebilirsiniz",
  "Following people has voted For this option:": "Aşağıdaki kişiler bu seçenek için oy kullandı:",
  "Total Number of Votes for this Option:": "Bu Seçenek İçin Toplam Oy Sayısı:",
  "Are you sure you want to complete this": "Bunu tamamlamak istediğinize emin misiniz",
  "Please complete all subtasks before marking the task as completed": "Görevi tamamlandı olarak işaretlemeden önce tüm alt görevleri tamamlayın",
  "wants to join a Group": "bir Gruba katılmak istiyor",
  "wants to publish an updated Group": "güncellenmiş bir Grup yayınlamak istiyor",
  "has updated the Group": "Grubu güncelledi",
  "invited you to": "sizi davet etti",
  "wants to publish a Group": "bir Grup yayınlamak istiyor",
  "has denied the Group": "Grubu reddetti",
  "has been added to the Group": "Gruba eklendi",
  "has published the Group": "Grubu yayınladı",
  "wants to publish a News": "bir Haber yayınlamak istiyor",
  "wants to publish an updated News": "güncellenmiş bir Haber yayınlamak istiyor",
  "has denied the News": "Haberi reddetti",
  "has published the News": "Haberi yayınladı",
  "has updated the News": "Haberi güncelledi",
  "wants to publish an Event": "bir Etkinlik yayınlamak istiyor",
  "wants to publish an updated Event": "güncellenmiş bir Etkinlik yayınlamak istiyor",
  "has denied the Event": "Etkinliği reddetti",
  "has published the Event": "Etkinliği yayınladı",
  "has updated the Event": "Etkinliği güncelledi",
  "invited you to an Event": "sizi bir Etkinliğe davet etti",
  "has updated Event for existing users": "var olan kullanıcılar için Etkinliği güncelledi",
  "has updated Course for existing users": "var olan kullanıcılar için Kursu güncelledi",
  "wants to publish a Course": "bir Kurs yayınlamak istiyor",
  "wants to publish an updated Course": "güncellenmiş bir Kurs yayınlamak istiyor",
  "wants to join a Course you have created": "oluşturduğunuz bir Kursa katılmak istiyor",
  "has been added to a Course by the creator": "oluşturan tarafından bir Kursa eklendi",
  "invited you to a Course": "sizi bir Kursa davet etti",
  "wants to assign Instructor to a Course": "bir Kursa Eğitmen atamak istiyor",
  "wants to update assigned Instructor of a Course": "bir Kursun atanan Eğitmenini güncellemek istiyor",
  "has published the Course": "Kursu yayınladı",
  "has updated the Course": "Kursu güncelledi",
  "has denied the Course": "Kursu reddetti",
  "invited you to a Task": "sizi bir Göreve davet etti",
  "wants to publish a Task": "bir Görev yayınlamak istiyor",
  "wants to publish an updated Task": "güncellenmiş bir Görev yayınlamak istiyor",
  "has unapproved the Task": "Görevin onayını kaldırdı",
  "has unapproved the Subtask": "Alt Görevin onayını kaldırdı",
  "has denied the Task": "Görevi reddetti",
  "has published the Task": "Görevi yayınladı",
  "has updated the Task": "Görevi güncelledi",
  "has completed the Task": "Görevi tamamladı",
  "has sent you a message": "size bir mesaj gönderdi",
  "wants to publish a Survey": "bir Anket yayınlamak istiyor",
  "wants to publish an updated Survey": "güncellenmiş bir Anket yayınlamak istiyor",
  "has invited you to participate in a Survey": "sizi bir Anket'e katılmaya davet etti",
  "has published the Survey": "Anketi yayınladı",
  "has updated the Survey": "Anketi güncelledi",
  "has denied the Survey": "Anketi reddetti",
  "wants to publish a Room": "bir Oda yayınlamak istiyor",
  "wants to publish an updated Room": "güncellenmiş bir Oda yayınlamak istiyor",
  "has published the Room": "Odayı yayınladı",
  "has updated the Room": "Odayı güncelledi",
  "has denied the Room": "Odayı reddetti",
  "wants to publish an Instructor": "bir Eğitmen yayınlamak istiyor",
  "wants to publish an updated Instructor": "güncellenmiş bir Eğitmen yayınlamak istiyor",
  "has denied the Instructor": "Eğitmeni reddetti",
  "has published the Instructor": "Eğitmeni yayınladı",
  "has updated the Instructor": "Eğitmeni güncelledi",
  "wants to publish an FAQ": "bir SSS yayınlamak istiyor",
  "wants to publish an updated FAQ": "güncellenmiş bir SSS yayınlamak istiyor",
  "has published the FAQ": "SSS'yi yayınladı",
  "wants to publish an updated FAQ to author": "bir SSS'nin güncellenmiş halini yazar olarak yayınlamak istiyor",
  "has denied the FAQ to author": "SSS'yi yazara reddetti",
  "wants to publish an FAQ category": "bir SSS kategorisi yayınlamak istiyor",
  "Unknown notification type": "Bilinmeyen bildirim türü",
  "Occupancy": "Dolu Kapasite",
  "Free": "Boş",
  "Calendar": "Takvim",
  "Jan": "Oca",
  "Feb": "Şub",
  "Mar": "Mar",
  "Apr": "Nis",
  "May": "May",
  "Jun": "Haz",
  "Jul": "Tem",
  "Aug": "Ağu",
  "Sep": "Eyl",
  "Oct": "Eki",
  "Nov": "Kas",
  "Dec": "Ara",
  "mo": "Pzts",
  "tu": "Sal",
  "we": "Çar",
  "th": "Per",
  "fr": "Cum",
  "sa": "Cts",
  "su": "Pzr",
  "mo 1": "P",
  "tu 1": "S",
  "we 1": "Ç",
  "th 1": "P",
  "fr 1": "C",
  "sa 1": "Ct",
  "su 1": "Pz",
  "current": "Güncel",
  "all": "Hepsi",
  "monday": "Pazartesi",
  "tuesday": "Salı",
  "wednesday": "Çarşamba",
  "thursday": "Perşembe",
  "friday": "Cuma",
  "saturday": "Cumartesi",
  "sunday": "Pazar",
  "january": "Ocak",
  "february": "Şubat",
  "march": "Mart",
  "april": "Nisan",
  "may": "Mayıs",
  "june": "Haziran",
  "july": "Temmuz",
  "august": "Ağustos",
  "september": "Eylül",
  "october": "Ekim",
  "november": "Kasım",
  "december": "Aralık",
  "just now": "az önce",
  "a minute ago": "bir dakika önce",
  "minutes ago": "dakika önce",
  "an hour ago": "bir saat önce",
  "hours ago": "saat önce",
  "yesterday": "dün",
  "a week ago": "bir hafta önce",
  "weeks ago": "hafta önce",
  "Click to download": "İndirmek için tıklayın",
  "other": "Diğer",
  "Members": "Üyeler",
  "Search Filter": "Arama Filtresi",
  "Search": "Ara",
  "Search Results": "Arama Sonuçları",
  "Last Active": "Son Etkinlik",
  "Status": "Durum",
  "Role": "Rol",
  "Online": "Çevrimiçi",
  "Offline": "Çevrimdışı",
  "List": "Liste",
  "Members List": "Üyeler Listesi",
  "Created": "Oluşturuldu",
  "Paid": "Ücretli",
  "Unpaid": "Ücretsiz",
  "Active": "Aktif",
  "Inactive": "Pasif",
  "Apply Filter": "Filtre Uygula",
  "Anonymous": "Anonim",
  "Show hidden events": "Gizli etkinlikleri göster",
  "Hide Event": "Etkinliği Gizle",
  "UnHide Event": "Etkinliği Göster",
  "Banner Placement": "Afiş Konumu",
  "Banner Display Tags": "Afiş Görüntüleme Etiketleri",
  "Create New Tag": "Yeni Etiket Oluştur",
  "Task Type": "Görev Türü",
  "Leave Event": "Etkinlikten Ayrıl",
  "Join Event": "Etkinliğe Katıl",
  "Join This Event": "Bu Etkinliğe Katıl",
  "Join All Events in Series": "Serideki Tüm Etkinliklere Katıl",
  "Join Event on Specific Dates": "Belirli Tarihlerdeki Etkinliğe Katıl",
  "Accept event": "Etkinliği kabul et",
  "Deny event": "Etkinliği reddet",
  "Publish event": "Etkinliği yayınla",
  "Event Members": "Etkinlik Üyeleri",
  "Event Tasks": "Etkinlik Görevleri",
  "Event Details": "Etkinlik Detayları",
  "About group": "Grup hakkında",
  "Show more": "Daha fazla göster",
  "Your team": "Ekibiniz",
  "Responsible": "Sorumlu",
  "Collaborators": "İş Birlikçileri",
  "Work Shifts": "Çalışma Vardiyaları",
  "Create Work Shift": "Çalışma Vardiyası Oluştur",
  "NO Of Shifts": "Vardiya Sayısı",
  "No Shifts Data found": "Vardiya Verisi Bulunamadı",
  "Error while fetching Shifts Details": "Vardiya Detayları getirilirken hata oluştu",
  "Shift": "Vardiya",
  "Form": "Form",
  "No new notifications": "Yeni bildirim yok",
  "No Data": "Veri Yok",
  "Add Work-shifts to an event": "Bir etkinliğe çalışma vardiyaları ekleyin",
  "Click to open details": "Detayları açmak için tıklayın",
  "permanently": "kalıcı olarak",
  "Folder": "Klasör",
  "Star Message": "Mesajı Yıldızla",
  "Unstar Message": "Yıldızı Kaldır",
  "Impressum": "Künye",
  "Terms and Conditions": "Şartlar ve Koşullar",
  "Terms of Use": "Kullanım Koşulları",
  "Privacy Policy": "Gizlilik Politikası",
  "You can find our applicable documents here": "Geçerli belgelerimizi burada bulabilirsiniz",
  "Club Administration": "Kulüp Yönetimi",
  "Financial Accounting": "Finansal Muhasebe",
  "License & More": "Lisans & Daha Fazlası",
  "Documents": "Belgeler",
  "Current Statuses": "Güncel Durumlar",
  "Corporate Philosophy": "Kurumsal Felsefe",
  "Corporate": "Kurumsal",
  "Archive": "Arşiv",
  "All": "Hepsi",
  "Tables": "Tablolar",
  "Images": "Görüntüler",
  "Delete File": "Dosyayı Sil",
  "Download File": "Dosyayı İndir",
  "Preview Image": "Görüntüyü Önizle",
  "Upload Document": "Belge Yükle",
  "Move to My Documents": "Belgelerime Taşı",
  "Move to Archived": "Arşive Taşı",
  "Move to Current Statuses": "Güncel Durumlara Taşı",
  "Move to CLub Documents": "Kulüp Belgelerine Taşı",
  "Move to Corporate Philosophy": "Kurumsal Felsefeye Taşı",
  "Move to Corporate Documents": "Kurumsal Belgelere Taşı",
  "Ascending": "Artan",
  "Descending": "Azalan",
  "Order By": "Sıralama Ölçütü",
  "Order": "Sıralama",
  "date": "Tarih",
  "name": "İsim",
  "Are you sure you want to move": "Taşımak istediğinize emin misiniz",
  "Document moved successfully": "Belge başarıyla taşındı",
  "Only PDF files are allowed in Current Statuses": "Güncel Durumlar bölümünde yalnızca PDF dosyalarına izin verilir",
  "Upload Successful": "Yükleme Başarılı",
  "Profile": "Profil",
  "Attachment": "Ek",
  "Download Attachment": "Eki İndir",
  "Author": "Yazar",
  "CRM Surveys": "CRM Anketleri",
  "CRM Survey": "CRM Anketi",
  "Voting Results": "Oylama Sonuçları",
  "Votes": "Oylar",
  "Total Votes": "Toplam Oy",
  "Close": "Kapat",
  "Thank you for your vote": "Oy verdiğiniz için teşekkürler",
  "By": "Oluşturan",
  "CRM News": "CRM Haberleri",
  "Read": "Oku",
  "Mark all notifications as read": "Tüm bildirimleri okundu olarak işaretle",
  "Close this notification": "Bu bildirimi kapat",
  "Phone": "Telefon",
  "Published by": "Yayınlayan",
  "Deleted User": "Silinmiş Kullanıcı",
  "Delete Chat": "Sohbeti Sil",
  "Availability": "Müsaitlik",
  "Enter Name": "İsim Girin",
  "Enter Email": "E-posta Girin",
  "Phone No": "Telefon No",
  "Enter Phone No": "Telefon Numarası Girin",
  "Enter Address": "Adres Girin",
  "No Of Persons": "Kişi Sayısı",
  "Enter No Of Persons": "Kişi Sayısı Girin",
  "Price": "Fiyat",
  "First Name": "Ad",
  "Enter First Name": "Adınızı Girin",
  "Last Name": "Soyad",
  "Enter Last Name": "Soyadınızı Girin",
  "Enter Qualification": "Yeterliliğinizi Girin",
  "Repeat Course": "Kursu Tekrarla",
  "Delete Selected": "Seçileni Sil",
  "Deselect All": "Tüm Seçimleri Kaldır",
  "Statistics": "İstatistikler",
  "Clicks": "Tıklamalar",
  "Banner Statistics": "Afiş İstatistikleri",
  "Banner Desktop Clicks": "Afiş Masaüstü Tıklamaları",
  "Select Admin": "Yönetici Seç",
  "Group Chat": "Grup Sohbeti",
  "Groupchat": "Grup Sohbeti",
  "Personal Chat": "Kişisel Sohbet",
  "Created By": "Oluşturan",
  "Invoice": "Fatura",
  "Profile Image": "Profil Resmi",
  "Share Birthday": "Doğum Gününü Paylaş",
  "Allow Advertisement": "Reklama İzin Ver",
  "Date From": "Tarih (Başlangıç)",
  "Date To": "Tarih (Bitiş)",
  "m ago": "{{count}} dakika önce",
  "h ago": "{{count}} saat önce",
  "d ago": "{{count}} gün önce",
  "w ago": "{{count}} hafta önce",
  "mo ago": "{{count}} ay önce",
  "Completed Subtasks": "Tamamlanan Alt Görevler",
  "Total Subtasks": "Toplam Alt Görev",
  "Task Assigned to": "Görev Atanan",
  "To be done by": "Tarafından yapılacak",
  "This Task Only Completed by Admin, Organizer and Collaborators of this Task": "Bu Görev yalnızca Yöneticiler, Organizatör ve bu Görevin İş Birlikçileri tarafından tamamlanabilir",
  "You do not have permission to complete this subtask, only participants of this Task & Subtasks, organizer of this task, and Administrator can complete this subtask": "Bu alt görevi tamamlamak için izniniz yok, yalnızca bu Göreve ve Alt Görevlere katılanlar, görevin düzenleyicisi ve Yöneticiler tamamlayabilir",
  "Free Space": "Boş Alan",
  "Desktop": "Web",
  "Notification Section": "Bildirim Bölümü",
  "Everywhere": "Her Yerde",
  "Welcome to your club community!": "Kulüp topluluğunuza hoş geldiniz!",
  "Stay networked with your club, exchange ideas and organize everything in one place.": "Kulübünüzle bağlantıda kalın, fikir alışverişi yapın ve her şeyi tek bir yerde organize edin.",
  "Everything you need for your club - in one place.": "Kulübünüz için ihtiyacınız olan her şey - tek bir yerde.",
  "Simply register, contact members, plan appointments and achieve more together.": "Sadece kaydolun, üyelerle iletişime geçin, randevular planlayın ve birlikte daha fazlasını başarın.",
  "Stay connected - anytime, anywhere.": "Her zaman, her yerde bağlantıda kalın.",
  "Access important information, share news and collaborate with your team.": "Önemli bilgilere erişin, haberleri paylaşın ve ekibinizle iş birliği yapın.",
  "Happy Birthday": "Mutlu Doğum Günü",
  "Happy Anniversary": "Mutlu Yıldönümleri",
  "Instant and uncomplicated chatting with members or groups": "Üyeler veya gruplarla anında ve kolay sohbet",
  "Your own mailbox based on the classic e-mail": "Klasik e-postaya dayalı kendi posta kutunuz",
  "Invalid file type or size. Only PNG, JPEG images and allowed documents under 10MB are allowed": "Geçersiz dosya türü veya boyutu. Sadece PNG, JPEG resimler ve 10MB altındaki belgeler kabul edilir",
  "Club Overview": "Kulüp Genel Bakış",
  "Happenings": "Olaylar",
  "Occasions": "Özel Günler",
  "No:": "No:",
  "Password changed successfully. Please login again": "Şifre başarıyla değiştirildi. Lütfen tekrar giriş yapın",
  "This is a private group. You need to request to join this group": "Bu özel bir grup. Bu gruba katılmak için istekte bulunmanız gerekiyor",
  "Your request to join this group is pending": "Bu gruba katılma isteğiniz bekliyor",
  "Your request to join this group has been rejected": "Bu gruba katılma isteğiniz reddedildi",
  "Confirm Delete": "Silme İşlemini Onayla",
  "No news has been created in the club yet": "Kulüpte henüz haber oluşturulmadı",
  "No news has been created in any Group yet": "Henüz hiçbir Grup'ta haber oluşturulmadı",
  "No group has been created in the club yet": "Kulüpte henüz grup oluşturulmadı",
  "No events available": "Kullanılabilir etkinlik yok",
  "Additional address": "Ek Adres",
  "You have no notifications": "Hiç bildiriminiz yok",
  "Information about the course": "Kurs hakkında bilgi",
  "Further information about the course": "Kurs hakkında daha fazla bilgi",
  "Invite Participants": "Katılımcıları Davet Et",
  "Select all": "Tümünü Seç",
  "Unselect all": "Tüm Seçimleri Kaldır",
  "Done": "Tamamlandı",
  "You already have a pending change request": "Zaten bekleyen bir değişiklik isteğiniz var",
  "Messages": "Mesajlar",
  "Calendar view": "Takvim görünümü",
  "Card view": "Kart görünümü",
  "Mark As Complete": "Tamamlandı Olarak İşaretle",
  "No Bookings": "Rezervasyon Yok",
  "Schedule view": "Program görünümü",
  "Hide Empty Slots": "Boş Zamanları Gizle",
  "Group Filter": "Grup Filtresi",
  "No Conversation": "Sohbet Yok",
  "Select Event Dates": "Etkinlik Tarihlerini Seç",
  "Select the dates you want to join for this event": "Bu etkinliğe katılmak istediğiniz tarihleri seçin",
  "Join Selected Dates": "Seçilen Tarihlere Katıl",
  "Selected": "Seçilen",
  "dates": "Tarihler",
  "new": "Yeni",
  "Please select at least one new date": "Lütfen en az bir yeni tarih seçin",
  "No available dates for this event": "Bu etkinlik için kullanılabilir tarih yok",
  "Accept This Event": "Bu Etkinliği Kabul Et",
  "Accept All Events in Series": "Serideki Tüm Etkinlikleri Kabul Et",
  "Accept Event on Specific Dates": "Belirli Tarihlerdeki Etkinliği Kabul Et",
  "DIVIDER": "-------------------------------------------------------------DIVIDER---------------------------------------------------------------------",
  "notification": {
    "Join Group": "bir Gruba katılmak istiyor",
    "Publish Event": "bir Etkinlik yayınlamak istiyor",
    "Publish Article": "bir Haber yayınlamak istiyor",
    "Publish Task": "bir Görev yayınlamak istiyor",
    "No Notification": "Hiç Bildiriminiz Yok",
    "Publish Course": "bir Kurs yayınlamak istiyor",
    "Publish Update Course": "güncellenmiş bir Kurs yayınlamak istiyor",
    "Publish Instructor": "bir Eğitmen yayınlamak istiyor",
    "Publish Room": "bir Oda yayınlamak istiyor",
    "Publish Survey": "bir Anket yayınlamak istiyor",
    "Publish Group": "bir Grup yayınlamak istiyor",
    "Publish Update Article": "güncellenmiş bir Haber yayınlamak istiyor",
    "Publish Update Group": "güncellenmiş bir Grup yayınlamak istiyor",
    "Publish Update Task": "güncellenmiş bir Görev yayınlamak istiyor",
    "Publish Update Instructor": "güncellenmiş bir Eğitmen yayınlamak istiyor",
    "Publish Update Room": "güncellenmiş bir Oda yayınlamak istiyor",
    "Publish Update Event": "güncellenmiş bir Etkinlik yayınlamak istiyor",
    "Deny Article": "haberi reddetti",
    "Deny Group": "grubu reddetti",
    "Deny Task": "görevi reddetti",
    "Deny Instructor": "eğitmeni reddetti",
    "Deny Room": "odayı reddetti",
    "Deny Event": "etkinliği reddetti",
    "Deny Course": "kursu reddetti",
    "Added Group": "gruba eklendi",
    "Group Has Been Updated": "Grup güncellendi",
    "Group Has Been Published": "Grup yayınlandı",
    "Task Has Been Updated": "Görev güncellendi",
    "Task Has Been Published": "Görev yayınlandı",
    "Task Completed": "görev tamamlandı",
    "Instructor Has Been Updated": "Eğitmen güncellendi",
    "Instructor Has Been Published": "Eğitmen yayınlandı",
    "Room Has Been Updated": "Oda güncellendi",
    "Room Has Been Published": "Oda yayınlandı",
    "Event Has Been Updated": "Etkinlik güncellendi",
    "Event Has Been Published": "Etkinlik yayınlandı",
    "Course Has Been Updated": "Kurs güncellendi",
    "Course Has Been Published": "Kurs yayınlandı",
    "Internal Instructor Assigned": "ve sizi dahili eğitmen olarak atadı",
    "Update Internal Instructor Assigned": "ve bu kurs size dahili eğitmen olarak atandı",
    "Survey Has Been Updated": "Anket güncellendi",
    "Survey Has Been Published": "Anket yayınlandı",
    "Want To Publish Update Survey Called": "güncellenmiş bir Anket yayınlamak istiyor",
    "Deny Survey Called": "anketi reddetti",
    "News Has Been Published": "Haber yayınlandı",
    "News Has Been Updated": "Haber güncellendi"
  },
  "formErrors": {
    "is required.": "gereklidir.",
    "is invalid.": "geçersizdir.",
    "is required to be at least": "en az şu kadar olmalıdır",
    "cannot be longer than": "daha uzun olamaz",
    "can't be greater than": "daha büyük olamaz",
    "can't be less than": "daha küçük olamaz",
    "must contain at least 1 in Capital Case!": "en az 1 Büyük Harf içermelidir!",
    "must contain at least 1 Letter in Small Case!": "en az 1 Küçük Harf içermelidir!",
    "must contain at least 1 Special Character!": "en az 1 Özel Karakter içermelidir!",
    "do not match.": "eşleşmiyor.",
    "must be unique.": "benzersiz olmalıdır.",
    "must be greater than 0.": "0'dan büyük olmalıdır.",
    "must be greater.": "daha büyük olmalıdır.",
    "must be greater than or equal.": "daha büyük veya eşit olmalıdır.",
    "must be after the start date.": "başlangıç tarihinden sonra olmalıdır.",
    "invalid pattern": "geçersiz desen",
    "invalid pattern, 12345-1234 or 12345": "geçersiz desen, 12345-1234 veya 12345"
  },
  "loginForm": {
    "Login into your account": "Hesabınıza giriş yapın",
    "Username": "Kullanıcı Adı",
    "Password": "Şifre",
    "Remember me": "Beni Hatırla",
    "I forgot my password": "Şifremi unuttum",
    "Don't have an account?": "Hesabınız yok mu?",
    "Login": "Giriş Yap",
    "Sign up for Verein.cloud": "Verein.cloud® için Kaydolun",
    "Password (6+ characters)": "Şifre (6+ karakter)"
  },
  "buttonComponent": {
    "Login": "Giriş Yap",
    "Success": "Başarılı",
    "Save": "Kaydet",
    "Processing": "İşleniyor",
    "Error": "Hata",
    "Cancel": "İptal",
    "done": "Tamam",
    "Join Event": "Etkinliğe Katıl",
    "Leave Event": "Etkinlikten Ayrıl"
  },
  "header": {
    "open": "Aç",
    "close": "Kapat",
    "start typing": "Yazmaya başlayın..",
    "messages": "Mesajlar"
  },
  "nav": {
    "event tasks": "Etkinlik Görevleri",
    "event members": "Etkinlik Üyeleri",
    "create event form": "Etkinlik Formu Oluştur",
    "dashboard": "Kontrol Paneli",
    "news": "Haberler",
    "clubWall": "Kulüp Duvarı",
    "community": "Topluluk",
    "organizer": "Düzenleyici",
    "courses": "Kurslar",
    "tasks": "Görevler",
    "appointments": "Randevular",
    "task&appointments": "Görevler & Randevular",
    "events": "Etkinlikler",
    "messages": "Mesajlar",
    "messages&groups": "Mesajlar & Gruplar",
    "settings": "Ayarlar",
    "groups": "Gruplar",
    "academic": "Akademik",
    "app store": "Uygulama Mağazası",
    "my profile": "Profilim",
    "profile": "Profil",
    "club tools": "Kulüp Araçları",
    "marketing": "Pazarlama",
    "marketing tools": "Pazarlama Araçları",
    "banners": "Afişler",
    "create banner": "Afiş Oluştur",
    "create event": "Etkinlik Oluştur",
    "emails": "E-postalar",
    "create email": "E-posta Oluştur",
    "tags": "Etiketler",
    "survey": "Anketler",
    "course management": "Kurs Yönetimi",
    "club FAQs": "Kulüp SSS",
    "group details": "Grup Detayları",
    "chat": "Sohbet",
    "events & club dates": "Etkinlikler & Kulüp Tarihleri",
    "club addons": "Kulüp Eklentileri",
    "more": "Daha Fazla",
    "documents": "Belgeler",
    "add": "Ekle",
    "faq": "SSS",
    "my content": "İçeriğim"
  },
  "community": {
    "group overview": "Grup Genel Bakışı",
    "dashboard": "Kontrol Paneli",
    "community": "Topluluk",
    "messages": "Mesajlar",
    "groups": "Gruplar",
    "members": "Üyeler",
    "open chat": "Sohbeti Aç",
    "leave": "Ayrıl",
    "edit": "Düzenle",
    "delete": "Sil",
    "add": "Ekle",
    "create": "Oluştur",
    "show all groups": "Tüm grupları göster",
    "groups you manage": "Yönettiğiniz gruplar",
    "groups you are a member of": "Üyesi olduğunuz gruplar"
  },
  "groups": {
    "groups": "Gruplar",
    "group": "Grup",
    "group details": "Grup Detayları",
    "members": "Üyeler",
    "news": "Haberler",
    "tasks": "Görevler",
    "events": "Etkinlikler",
    "about": "Hakkında",
    "About this group": "Bu grup hakkında",
    "set": "Ayarla",
    "your team": "Ekibiniz",
    "new": "Yeni",
    "group admin": "Grup yöneticisi",
    "age": "yaş",
    "no group": "Grup yok",
    "no event": "Etkinlik yok",
    "no task": "Görev yok",
    "no news": "Haber yok",
    "no member": "Üye yok",
    "join success message": "Gruba başarıyla katıldınız.",
    "waiting admin approval": "Yönetici onayı bekleniyor",
    "leave success message": "Gruptan başarıyla ayrıldınız.",
    "delete success message": "Grup başarıyla silindi."
  },
  "banners": {
    "link": "Bağlantı",
    "content": "İçerik",
    "description": "Açıklama",
    "banner status": "Durum",
    "update courses": "Kursları Güncelle",
    "banner invoice": "Fatura",
    "banner category": "Kategori",
    "banner categories": "Afiş Kategorileri",
    "banner images": "Afiş Görselleri",
    "add description": "Açıklama Ekle",
    "create banner": "Afiş Oluştur",
    "thumbnail": "Küçük Resim",
    "add image": "Görüntü Ekle",
    "title": "Başlık",
    "sponsor": "Sponsor",
    "open space": "Açık Alan",
    "app sponsor": "Uygulama Sponsoru",
    "group details": "Grup Detayları",
    "all groups": "Tüm Gruplar",
    "all news": "Tüm Haberler",
    "not paid": "Ödenmedi",
    "save": "Kaydet",
    "cancel": "İptal",
    "banner link": "Afiş Bağlantısı",
    "banner title": "Afiş Başlığı",
    "edit banner": "Afişi Düzenle",
    "banner display": "Görüntüleme",
    "news details": "Haber Detayları",
    "banner placement": "Afiş Konumu",
    "banner display tag": "Afiş Görüntüleme Etiketi",
    "banner redirect link": "Afiş Yönlendirme Bağlantısı"
  },
  "dates&filters": {
    "date": "Tarih",
    "days": "Günler",
    "day": "Gün",
    "hour": "Saat",
    "hours": "Saat",
    "time": "Zaman",
    "year": "Yıl",
    "years": "Yıllar",
    "month": "Ay",
    "months": "Aylar",
    "week": "Hafta",
    "weeks": "Haftalar",
    "opinion": "Görüş",
    "event type": "Etkinlik Türü",
    "sort and filter": "Sırala ve Filtrele",
    "clear filters": "Filtreleri Temizle",
    "clear": "Temizle",
    "expired": "Süresi Dolmuş"
  },
  "messages": {
    "new group": "Yeni grup",
    "new chat": "Yeni sohbet",
    "chat": "Sohbet",
    "personal": "Kişisel",
    "club": "Kulüp",
    "group": "Grup",
    "clubs": "Kulüpler",
    "members": "Üye",
    "write a message": "Bir mesaj yaz",
    "media links and docs": "Medya, Bağlantılar ve Belgeler",
    "group in common": "Ortak Grup",
    "close": "Kapat",
    "group name": "Grup adı",
    "cancel": "İptal",
    "save": "Kaydet",
    "delete": "Sil",
    "report": "Rapor"
  },
  "users": {
    "my profile": "Profilim",
    "user profile": "Kullanıcı Profili",
    "user": "Kullanıcı",
    "general information": "Genel Bilgiler",
    "my payment data": "Ödeme Bilgilerim",
    "association master data": "Dernek Ana Verileri",
    "me at the club": "Kulüpteki durumum",
    "I in the company": "Şirketteki durumum",
    "my address information": "Adres Bilgilerim",
    "communication data": "İletişim Verileri",
    "street number": "Sokak Numarası",
    "more info": "Daha Fazla Bilgi",
    "city": "Şehir",
    "zip code": "Posta Kodu",
    "e-mail address": "E-posta Adresi",
    "phone number": "Telefon Numarası",
    "date of birth": "Doğum Tarihi",
    "address supplement": "Adres Eki",
    "save profile": "Profili Kaydet",
    "password information": "Şifre Bilgisi",
    "old password": "Eski Şifre",
    "minimum 6 characters": "En az 6 karakter",
    "change": "Değiştir",
    "bank holder name": "Hesap Sahibi Adı",
    "iban": "IBAN",
    "bic": "BIC",
    "social links": "Sosyal Bağlantılar",
    "facebook": "Facebook",
    "twitter": "Twitter",
    "instagram": "Instagram",
    "homepage": "Ana Sayfa",
    "country": "Ülke",
    "bank name": "Banka Adı",
    "member ship start date": "Üyeliğin Başlangıç Tarihi",
    "My role in verein.cloud®": "verein.cloud®'daki rolüm"
  },
  "club_tools": {
    "create question": "Soru Oluştur",
    "faq categories": "SSS Kategorileri",
    "start searching": "Aramaya başlayın",
    "membership": "Üyelik",
    "maintenance and care": "Bakım ve ilgi",
    "create faq": "SSS Oluştur",
    "update faq": "SSS Güncelle",
    "create title": "Başlık oluştur",
    "add description here": "Buraya açıklama ekleyin"
  },
  "courses": {
    "instructors": "Eğitmenler",
    "rooms": "Odalar",
    "all instructors": "Tüm Eğitmenler",
    "all rooms": "Tüm Odalar",
    "today": "Bugün",
    "upcoming": "Yaklaşan",
    "join": "Katıl",
    "joined": "Katıldı",
    "rejected": "Reddedildi",
    "persons": "Kişiler",
    "search by room name": "Oda adına göre ara",
    "join course": "Kursa katıl",
    "sorting": "Sıralama",
    "participants": "Katılımcılar",
    "about course": "Kurs Hakkında",
    "course details": "Kurs Detayları"
  },
  "appointmentAndClub": {
    "active": "Aktif",
    "start time": "Başlangıç Saati",
    "end time": "Bitiş Saati",
    "visibility": "Görünürlük",
    "event name": "Etkinlik Adı",
    "event location": "Etkinlik Konumu",
    "room number (optional)": "Oda Numarası (isteğe bağlı)",
    "event price": "Etkinlik Ücreti",
    "additional features": "Ek Özellikler",
    "show guests": "Misafirleri Göster",
    "chargeable": "Ücretli",
    "create event": "Etkinlik Oluştur",
    "edit event": "Etkinliği Düzenle",
    "canceled": "İptal Edildi",
    "pending": "Beklemede",
    "confirmed": "Onaylandı",
    "location": "Lokasyon",
    "responsible": "Sorumlu",
    "join event": "Etkinliğe Katıl",
    "current": "Güncel",
    "tile view": "Kutucuk Görünümü",
    "list view": "Liste Görünümü",
    "board": "Tahta",
    "view": "Görüntüle",
    "my contributions": "Katkılarım",
    "Birthdays and anniversaries in the club": "Kulüpteki doğum günleri ve yıldönümleri",
    "Current events in the club": "Kulüpteki güncel etkinlikler",
    "Current events in the company": "Şirketteki güncel etkinlikler"
  },
  "my content": {
    "title image": "Başlık resmi",
    "type": "Tür",
    "actions": "Eylemler",
    "faqs": "SSS"
  },
  "userprofile": {
    "personal information": "Kişisel Bilgiler",
    "create profile": "Profil Oluştur",
    "edit my profile": "Profilimi Düzenle",
    "digital membership card": "Dijital üyelik kartı",
    "payment information": "Ödeme bilgileri",
    "digital card": "Dijital Kart",
    "card holder name": "Kart Sahibi Adı",
    "card number": "Kart Numarası",
    "card type": "Kart Türü",
    "expiration date": "Son Kullanma Tarihi",
    "membership information": "Üyelik Bilgileri",
    "membership type": "Üyelik Türü",
    "membership number": "Üyelik Numarası",
    "In the team since": "Takımda olduğu tarih",
    "approval / activation": "Onay / Etkinleştirme",
    "fair-share function": "Adil Paylaşım Fonksiyonu"
  },
  "RRULE": {
    "approximate": "yaklaşık",
    "and": "ve",
    "at": "saat",
    "day": "gün",
    "days": "gün",
    "every": "her",
    "for": "için",
    "hour": "saat",
    "hours": "saat",
    "in": "içinde",
    "last": "son",
    "minutes": "dakika",
    "month": "ay",
    "months": "ay",
    "nd": "nd",
    "on the": "tarihinde",
    "on": "üzerinde",
    "or": "veya",
    "rd": "rd",
    "st": "st",
    "th": "th",
    "the": "the",
    "time": "zaman",
    "times": "kez",
    "until": "kadar",
    "week": "hafta",
    "weekday": "hafta içi",
    "weekdays": "hafta içleri",
    "weeks": "hafta",
    "year": "yıl",
    "years": "yıl",
    "monthly": "ay",
    "yearly": "yıl",
    "weekly": "hafta",
    "daily": "gün",
    "hourly": "saat",
    "minutely": "dakika",
    "secondly": "saniye",
    "starting from": "başlangıç",
    "MO": "Pazartesi",
    "TU": "Salı",
    "WE": "Çarşamba",
    "TH": "Perşembe",
    "FR": "Cuma",
    "SA": "Cumartesi",
    "SU": "Pazar",
    "RRule error: Unable to fully convert this rrule to text": "RRule hatası: Bu rrule metne tam olarak dönüştürülemiyor"
  }
}
